import {createSlice, ActionReducerMapBuilder} from '@reduxjs/toolkit'
import {
  OverviewAnalyticsState,
  OverviewViolationsState,
  SliceStatus,
} from 'interfaces'
import {
  getOverviewViolations,
  getOverviewViolationsSuccess,
  getOverviewViolationsFailure,
  getOverviewAnalytics,
  getOverviewAnalyticsSuccess,
  getOverviewAnalyticsFailure,
} from './analyticsOverviewActions'

const initialOverviewViolationState: OverviewViolationsState = {
  totalViolations: 0,
  mostViolatedCategory: '',
  status: SliceStatus.idle,
  error: '',
}

const overviewViolationsSlice = createSlice({
  name: 'overviewViolations',
  initialState: initialOverviewViolationState,
  reducers: {},
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  extraReducers: (builder: ActionReducerMapBuilder<any>) =>
    builder
      .addCase(getOverviewViolations, state => ({
        ...state,
        status: SliceStatus.pending,
      }))
      .addCase(getOverviewViolationsSuccess, (state, action) => ({
        ...state,
        status: SliceStatus.resolved,
        totalViolations: action?.payload?.totalViolations || 0,
        mostViolatedCategory: action?.payload?.mostViolatedCategory || '',
        error: '',
      }))
      .addCase(getOverviewViolationsFailure, state => ({
        ...state,
        status: SliceStatus.rejected,
        totalViolations: 0,
        mostViolatedCategory: '',
      }))
      .addDefaultCase(state => state),
})

export const {
  reducer: overviewViolationsReducer,
  name: overviewViolationsReducerName,
} = overviewViolationsSlice

export type OverviewViolationReducerState = ReturnType<
  typeof overviewViolationsReducer
>

const initialOverviewAnalyticsState: OverviewAnalyticsState = {
  topCategory: '',
  topCloudApp: '',
  status: SliceStatus.idle,
  error: '',
}

const overviewAnalyticsSlice = createSlice({
  name: 'overviewAnalytics',
  initialState: initialOverviewAnalyticsState,
  reducers: {},
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  extraReducers: (builder: ActionReducerMapBuilder<any>) =>
    builder
      .addCase(getOverviewAnalytics, state => ({
        ...state,
        status: SliceStatus.pending,
      }))
      .addCase(getOverviewAnalyticsSuccess, (state, action) => ({
        ...state,
        status: SliceStatus.resolved,
        topCategory: action?.payload?.topCategory || '',
        topCloudApp: action?.payload?.topCloudApp || '',
        error: '',
      }))
      .addCase(getOverviewAnalyticsFailure, state => ({
        ...state,
        status: SliceStatus.rejected,
        topCategory: '',
        topCloudApp: '',
      }))
      .addDefaultCase(state => state),
})

export const {
  reducer: overviewAnalyticsReducer,
  name: overviewAnalyticsReducerName,
} = overviewAnalyticsSlice

export type OverviewAnalyticsReducerState = ReturnType<
  typeof overviewAnalyticsReducer
>

// export analytics overview action types
export type TAnalyticsOverviewActions =
  | ReturnType<typeof getOverviewViolations>
  | ReturnType<typeof getOverviewViolationsSuccess>
  | ReturnType<typeof getOverviewViolationsFailure>
  | ReturnType<typeof getOverviewAnalytics>
  | ReturnType<typeof getOverviewAnalyticsSuccess>
  | ReturnType<typeof getOverviewAnalyticsFailure>

export const analyticsOverviewActions = {
  getOverviewViolations,
  getOverviewViolationsSuccess,
  getOverviewViolationsFailure,
  getOverviewAnalytics,
  getOverviewAnalyticsSuccess,
  getOverviewAnalyticsFailure,
}
